module.exports = __webpack_public_path__ + "img/8_cover1.0faa212b.png";